import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Download, Eye } from "lucide-react";
import { Document, Page, pdfjs } from "react-pdf";
import pdf from "../../Assets/Vijay_Resume.pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="relative min-h-screen py-32 bg-dark overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16 space-y-6"
        >
          <h1 className="text-4xl md:text-6xl font-bold font-manrope">
            My <span className="text-primary">Resume</span>
          </h1>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href={pdf}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 px-8 py-4 bg-primary rounded-2xl text-white font-bold shadow-[0_0_20px_rgba(205,95,248,0.3)] hover:shadow-[0_0_30px_rgba(205,95,248,0.5)] transition-all"
            >
              <Download size={20} />
              Download CV
            </motion.a>
            
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href={pdf}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 px-8 py-4 glass border-white/10 rounded-2xl text-white font-bold hover:bg-white/10 transition-all"
            >
              <Eye size={20} />
              View Fullscreen
            </motion.a>
          </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
          className="flex justify-center glass p-4 md:p-8 rounded-3xl border-white/5 shadow-2xl bg-surface/30 overflow-hidden"
        >
          <Document file={pdf} className="flex flex-col items-center">
            <Page
              pageNumber={1}
              scale={width > 1200 ? 1.7 : width > 786 ? 1.2 : 0.6}
              className="shadow-2xl rounded-lg overflow-hidden border border-white/10"
              renderTextLayer={false}
              renderAnnotationLayer={false}
            />
          </Document>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-12 flex justify-center"
        >
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            href={pdf}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 px-8 py-4 bg-primary/10 border border-primary/20 rounded-2xl text-primary font-bold hover:bg-primary hover:text-white transition-all"
          >
            <Download size={20} />
            Download CV
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
}

export default ResumeNew;
